import { Button, message } from 'antd';

export const handleGoogleAPIError = (error) => {
  if (error.response?.data?.requires_reauth) {
    message.warning('Google authorization has expired. Redirecting to settings...', 3);
    setTimeout(() => {
      window.location.href = `${window.wpAiWorkflowsSettings.adminUrl}admin.php?page=wp-ai-workflows&action=settings`;
    }, 3000);
    return true;
  }

  if (error.response?.status === 403 && error.response?.data?.code === 'google_not_integrated') {
    message.warning('Google integration not set up. Redirecting to settings...', 3);
    setTimeout(() => {
      window.location.href = `${window.wpAiWorkflowsSettings.adminUrl}admin.php?page=wp-ai-workflows&action=settings`;
    }, 3000);
    return true;
  }

  return false;
};

export const GoogleIntegrationStatus = ({ children }) => {
  return (
    <div className="google-integration-notice" style={{ marginBottom: '16px' }}>
      <div style={{ 
        padding: '12px', 
        background: '#f6f6f7', 
        border: '1px solid #e1e1e1',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
      }}>
        <img 
          src="https://www.google.com/images/branding/googlelogo/1x/googlelogo_color_272x92dp.png" 
          alt="Google Logo" 
          style={{ height: '20px', width: 'auto' }}
        />
        {children}
        <Button 
          type="primary" 
          size="small"
          onClick={() => {
            window.location.href = `${window.wpAiWorkflowsSettings.adminUrl}admin.php?page=wp-ai-workflows&action=settings`;
          }}
        >
          Configure
        </Button>
      </div>
    </div>
  );
};